import React, { Dispatch, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { IAppReduxStore } from '../../../../redux/store';
import { useParams } from 'react-router-dom';
import { useEnqueueSnackbar } from '../../../../hooks/useEnqueueSnackbar';
import {
    fetchImportDocTypes,
    fetchImportViewData,
    fetchImportViews,
} from '../../../../util/ImportUtils';
import { ToastSeverity } from '../../Toast/Toast';
import {
    closeDeleteImportDocumentsDialog,
    onConfirmDeleteDocuments,
} from '../../../../redux/import/sliceImportDeleteDocuments';
import { updateSelectedDocuments } from '../../../../redux/project/documents/sliceProjectSelectedDocuments';
import AlertModalDialog from '../AlertModalDialog';

export default () => {
    const { t } = useTranslation('translations', { keyPrefix: 'deleteDocumentsDialog' });
    const dispatch: Dispatch<unknown> = useDispatch();
    const { replicaId, areaName } = useParams();

    const enqueueSnackbar = useEnqueueSnackbar();

    const isDialogOpen = useSelector(
        (_store: IAppReduxStore) => _store.importDeleteDocuments.isDialogOpen,
    );

    const isLoading = useSelector((_store: IAppReduxStore) => _store.importDeleteDocuments.loading);

    const isDeletionCompleted = useSelector(
        (_store: IAppReduxStore) => _store.importDeleteDocuments.isDeletionCompleted,
    );
    const documentsNotDeleted = useSelector(
        (_store: IAppReduxStore) => _store.importDeleteDocuments.documentsNotDeleted,
    );
    const selectedDocumentIds = useSelector(
        (store: IAppReduxStore) => store.projectSelectedDocuments.storage.documentIds,
    );

    const handleDeleteCompletion = () => {
        fetchImportViews(replicaId);
        fetchImportViewData(replicaId);
        fetchImportDocTypes(replicaId);

        dispatch(
            updateSelectedDocuments({
                replicaId,
                areaName,
                documentIds: documentsNotDeleted.map(doc => doc.universalId),
            }),
        );

        documentsNotDeleted?.length > 0
            ? enqueueSnackbar(
                  t('toastError', { numberOfErrorDocuments: documentsNotDeleted.length }),
                  {
                      severity: ToastSeverity.Error,
                  },
              )
            : enqueueSnackbar(
                  t('toastSuccess', { numberOfDocuments: selectedDocumentIds.length }),
                  {
                      severity: ToastSeverity.Success,
                  },
              );

        onClose();
    };

    useEffect(() => {
        if (isDeletionCompleted) {
            handleDeleteCompletion();
        }
    }, [isDeletionCompleted]);

    const onDelete = () => {
        dispatch(
            onConfirmDeleteDocuments({
                documentIds: selectedDocumentIds,
                replicaId,
            }),
        );
    };

    const onClose = () => {
        dispatch(closeDeleteImportDocumentsDialog());
    };
    return (
        <AlertModalDialog
            isOpen={isDialogOpen}
            onClose={onClose}
            onConfirm={onDelete}
            onCancel={onClose}
            dialogTitle={t('dialogTitle')}
            dialogBody={t('body', { numberOfDocuments: selectedDocumentIds.length })}
            confirmText={t('ctaDelete')}
            cancelText={t('ctaCancel')}
            isActionDisabled={isLoading}
        />
    );
};
